import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

import { UserService, RedirectService } from '../global';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard {
    constructor(
        private router: Router,
        private userService: UserService,
        private redirectService: RedirectService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.userService.login$.pipe(
            debounceTime(1000),
            map((l) => {
                const allowedRoles: string[] = route.data['roles'] || ['app_admin'];
                const hasRole = allowedRoles.some((r) => l.user?.roles?.includes(r));

                if (!hasRole) {
                    console.log('Navigating back to home because user lacks required roles:', allowedRoles);
                    this.redirectService.setRedirectUrl(state.url);
                    return this.router.parseUrl('/');
                }
                return true;
            })
        );
    }
}
